import Button from 'react-bootstrap/Button'
import { Alert } from 'react-bootstrap'
import * as H from 'history'
import  React from 'react'
import { Fragment } from 'react'
import { ClaimController } from '../../controllers/ClaimController'
import { AdvertisingEntry } from '../../models/AdvertisingEntry'
import { ClaimModel } from '../../models/ClaimModel'
import { ClaimRelationship } from '../../models/ClaimRelationship'
import { EventPromoterEntry } from '../../models/EventPromoterEntry'
import { FinancialAssistance } from '../../models/FinancialAssistance'
import { FreeSampleEntry } from '../../models/FreeSampleEntry'
import { GoodsEntry } from '../../models/GoodsEntry'
import { IntellectualPropertyInsuranceEntry } from '../../models/IntellectualPropertyInsuranceEntry'
import { IntellectualPropertyRegistrationEntry } from '../../models/IntellectualPropertyRegistrationEntry'
import { MarketingConsultant } from '../../models/MarketingConsultant'
import { MarketingConsultantEntry } from '../../models/MarketingConsultantEntry'
import { MarketingVisitEntry } from '../../models/MarketingVisitEntry'
import { OverseasBuyerEntry } from '../../models/OverseasBuyerEntry'
import { PromotionalEventEntry } from '../../models/PromotionalEventEntry'
import { RelatedEntityEntry } from '../../models/RelatedEntityEntry'
import { Representation } from '../../models/Representation'
import { RepresentationEntry } from '../../models/RepresentationEntry'
import { ServicesIPRKnowHowEntry } from '../../models/ServicesIPRKnowHowEntry'
import { Stakeholder } from '../../models/Stakeholder'
import { TourismServicesEntry } from '../../models/TourismServicesEntry'
import { ISupportSpinner } from '../../shared/Ajax'
import { Backdrop } from '../../shared/Backdrop'
import {
  IField, MultiLineField, validateFields, yesNoDataSource,
} from '../../shared/fields'
import { BooleanButtonField, NumericButtonField } from '../../shared/fields/ButtonField'
import { Option } from '../../shared/fields/Options'
import { Table } from '../../shared/table'
import { BusinessCategories, PerformanceMeasures } from '../../shared/Utility'
import { NextBackButtons } from './controls/NextBackButtons'
import { ApplicationForm1DocumentSection } from './documents/DocumentSection'
import { areAnyDocumentsPendingScoring, documentTypeInfo, invalidDocumentUploaded } from './documents/DocumentTypeInfo'
import { calculateExpenses, GrantEstimation } from './GrantEstimation'
import { financialAssistanceColumns, FinancialAssistanceDetails } from './otherTables/financialAssistance/FinancialAssistanceDetails'
import { relationshipColumns, RelationshipDetails } from './otherTables/relationships/RelationshipDetails'
import { stakeholderColumns, StakeholderDetails } from './otherTables/stakeholders/StakeholderDetails'
import {
  calculateEventPromoterTotal, eventPromoterEntryColumns, EventPromoterEntryDetails, sortEventPromoters,
} from './schedules/Earnings/EventPromoterEntryDetails'
import {
  calculateGoodsTotal, goodsEntryColumns, GoodsEntryDetails, sortGoods,
} from './schedules/Earnings/GoodsEntryDetails'
import {
  calculateRelatedEntityTotal, relatedEntityEntryColumns, RelatedEntityEntryDetails, sortRelatedEntities,
} from './schedules/Earnings/RelatedEntityEntryDetails'
import {
  calculateServicesIPRKnowHowTotal, servicesIPRKnowHowEntryColumns, ServicesIPRKnowHowEntryDetails, sortServicesIPRKnowHow,
} from './schedules/Earnings/ServicesIPRKnowHowEntryDetails'
import {
  calculateTourismServicesTotal, sortTourismServices, tourismServicesEntryColumns, TourismServicesEntryDetails,
} from './schedules/Earnings/TourismServicesEntryDetails'
import {
  advertisingEntryColumns, AdvertisingEntryDetails, calculateAdvertisingTotal, sortAdvertising,
} from './schedules/Expenses/AdvertisingEntryDetails'
import {
  calculateFreeSampleTotal, freeSampleEntryColumns, FreeSampleEntryDetails, sortFreeSamples,
} from './schedules/Expenses/FreeSampleEntryDetails'
import {
  calculateIntellectualPropertyInsuranceTotal, intellectualPropertyInsuranceEntryColumns, IntellectualPropertyInsuranceEntryDetails, sortIntellectualPropertyInsurance,
} from './schedules/Expenses/IntellectualPropertyInsuranceEntryDetails'
import {
  calculateIntellectualPropertyRegistrationTotal, intellectualPropertyRegistrationEntryColumns, IntellectualPropertyRegistrationEntryDetails, sortIntellectualPropertyRegistration,
} from './schedules/Expenses/IntellectualPropertyRegistrationEntryDetails'
import { calculateAllConsultantsTotal, marketingConsultantColumns, MarketingConsultantDetails } from './schedules/Expenses/MarketingConsultantDetails'
import {
  calculateMarketingConsultantTotal, marketingConsultantEntryColumns, MarketingConsultantEntryDetails, sortMarketingConsultantEntries,
} from './schedules/Expenses/MarketingConsultantEntryDetails'
import {
  calculateMarketingVisitTotal, marketingVisitEntryColumns, MarketingVisitEntryDetails, sortMarketingVisits,
} from './schedules/Expenses/MarketingVisitEntryDetails'
import {
  calculateOverseasBuyerTotal, overseasBuyerEntryColumns, OverseasBuyerEntryDetails, sortOverseasBuyers,
} from './schedules/Expenses/OverseasBuyerEntryDetails'
import {
  calculatePromotionalEventTotal, promotionalEventEntryColumns, PromotionalEventEntryDetails, sortPromotionalEvents,
} from './schedules/Expenses/PromotionalEventEntryDetails'
import { calculateAllRepresentativesTotal, representationColumns, RepresentationDetails } from './schedules/Expenses/RepresentationDetails'
import {
  calculateRepresentationTotal, representationEntryColumns, RepresentationEntryDetails, sortRepresentationEntries,
} from './schedules/Expenses/RepresentationEntryDetails'

export interface PreparePageProps {
    history: H.History
    model: ClaimModel
    markets: Option<string>[]
    onChange: { (changes: Partial<ClaimModel>, callback?: { (): any }): any }
    preview?: boolean
    addressCountries: Option<string>[]
    lowRiskMarkets: string[]
}

export interface PreparePageState {
    loading: boolean
    validated: boolean
}

export class PreparePage extends React.Component<PreparePageProps, PreparePageState> implements ISupportSpinner {
    stakeholders: Table<Stakeholder>
    financialAssistance: Table<FinancialAssistance>
    relationships: Table<ClaimRelationship>
    representation: Table<Representation>
    marketingConsultant: Table<MarketingConsultant>
    marketingVisits: Table<MarketingVisitEntry>
    freeSamples: Table<FreeSampleEntry>
    promotionalEvents: Table<PromotionalEventEntry>
    advertising: Table<AdvertisingEntry>
    overseasBuyers: Table<OverseasBuyerEntry>
    intellectualPropertyRegistration: Table<IntellectualPropertyRegistrationEntry>
    intellectualPropertyInsurance: Table<IntellectualPropertyInsuranceEntry>
    goods: Table<GoodsEntry>
    servicesIPRKnowHow: Table<ServicesIPRKnowHowEntry>
    tourismServices: Table<TourismServicesEntry>
    eventPromoters: Table<EventPromoterEntry>
    relatedEntities: Table<RelatedEntityEntry>
    documents: { [code: string]: { [item: string]: ApplicationForm1DocumentSection } }
    performanceMeasure: NumericButtonField
    serviceIPRKnowHowDescription: MultiLineField
    tourismServiceDescription: MultiLineField
    docConfirmedAsValid: BooleanButtonField
    documentTimer: NodeJS.Timeout
    expensesError: HTMLDivElement
    representationEntry: Table<RepresentationEntry>
    marketingConsultantsEntry: Table<MarketingConsultantEntry>

    ajax: ClaimController
    documentRefreshAjax: ClaimController

    constructor(props: PreparePageProps) {
      super(props)

      this.ajax = new ClaimController()
      this.documentRefreshAjax = new ClaimController()

      this.state = {
        loading: false,
        validated: false,
      }
    }

    toggleSpinner(on: boolean, callback: { (): any }): void {
      this.setState({ loading: on }, callback)
    }

    areExpensesValid(): boolean {
      if (calculateExpenses(this.props.model).total < 15000) { return false }

      return true
    }

    next = () => {
      const documentsToValidate: IField[] = []

      for (const t of documentTypeInfo) {
        const items = t.reducer(this.props.model, this.props.lowRiskMarkets)
        for (const i of items) {
          if (this.documents && this.documents[t.code] && this.documents[t.code][i]) {
            documentsToValidate.push(this.documents[t.code][i])
          }
        }
      }

      this.setState({ validated: true }, () => {
        validateFields((res) => {
          if (!this.areExpensesValid()) {
            this.expensesError.focus()
            return
          }

          if (res) {
            if (this.props.model.machineLearningWithScore && areAnyDocumentsPendingScoring(this.props.model, this.props.lowRiskMarkets)) {
              alert('Please wait for the documents to be validated before submitting the form.')
              return
            }

            this.props.history.push(`/claim/${this.props.model.claimId}/review`)
          }
        },
        this.stakeholders,
        this.financialAssistance,
        this.relationships,
        this.representation,
        this.marketingConsultant,
        this.marketingVisits,
        this.freeSamples,
        this.promotionalEvents,
        this.advertising,
        this.overseasBuyers,
        this.intellectualPropertyRegistration,
        this.intellectualPropertyInsurance,
        this.goods,
        this.serviceIPRKnowHowDescription,
        this.servicesIPRKnowHow,
        this.tourismServiceDescription,
        this.tourismServices,
        this.eventPromoters,
        this.relatedEntities,
        this.performanceMeasure,
        this.docConfirmedAsValid,
        ...documentsToValidate)
      })
    }

    changeAndSave = (changes: Partial<ClaimModel>) => {
      this.props.onChange({ ...changes }, () => {
        this.ajax.updateClaim(this, this.props.model, () => { })
      })
    }

    setDocumentRef(code: string, item: string, r: ApplicationForm1DocumentSection) {
      if (!this.documents) {
        this.documents = {}
      }
      if (!this.documents[code]) {
        this.documents[code] = {}
      }
      this.documents[code][item] = r
    }

    refreshDocuments = () => {
      // console.log(`${(new Date()).getHours() + 1}:${(new Date()).getMinutes()}:${(new Date()).getSeconds()} - Refresh called. Timer is: ${this.documentTimer}`)
      if (areAnyDocumentsPendingScoring(this.props.model, this.props.lowRiskMarkets)) {
        this.documentRefreshAjax.getDocuments(null, this.props.model.claimId, (d) => {
          this.props.onChange({ documents: d })

          if (this.props.model.machineLearningWithScore) {
            this.documentTimer = setTimeout(this.refreshDocuments, 30000)
          }
          // console.log(`${(new Date()).getHours() + 1}:${(new Date()).getMinutes()}:${(new Date()).getSeconds()} - Started new timer: ${this.documentTimer}`)
        })
      }
    }

    componentDidMount() {
      this.refreshDocuments()
    }

    componentWillUnmount() {
      this.documentRefreshAjax.cancel()
      if (this.documentTimer) {
        // console.log(`${(new Date()).getHours() + 1}:${(new Date()).getMinutes()}:${(new Date()).getSeconds()} - Clearing timer: ${this.documentTimer}`)
        clearTimeout(this.documentTimer)
      }
    }

    render() {
      const performanceMeasureDataSource = [
        { value: PerformanceMeasures.OptionA, label: 'Option A' }, // EPT
        { value: PerformanceMeasures.OptionB, label: 'Option B' }, // ANB
      ]

      const repEntryColumns = [...representationEntryColumns(this.props.markets)]
      const marketingConsultantsEntryColumns = [...marketingConsultantEntryColumns(this.props.markets)]

      // #region Sorting Lists

      // Expenses
      const sortedMarketingVisits = this.props.model.marketingVisitEntries.slice()
      sortedMarketingVisits.sort((a, b) => sortMarketingVisits(a, b))

      const sortedFreeSamples = this.props.model.freeSampleEntries.slice()
      sortedFreeSamples.sort((a, b) => sortFreeSamples(a, b))

      const sortedPromotionalEvents = this.props.model.promotionalEventEntries.slice()
      sortedPromotionalEvents.sort((a, b) => sortPromotionalEvents(a, b))

      const sortedAdvertising = this.props.model.advertisingEntries.slice()
      sortedAdvertising.sort((a, b) => sortAdvertising(a, b))

      const sortedOverseasBuyer = this.props.model.overseasBuyerEntries.slice()
      sortedOverseasBuyer.sort((a, b) => sortOverseasBuyers(a, b))

      const sortedIntellectualPropertyRegistration = this.props.model.intellectualPropertyRegistrationEntries.slice()
      sortedIntellectualPropertyRegistration.sort((a, b) => sortIntellectualPropertyRegistration(a, b))

      const sortedIntellectualPropertyInsurance = this.props.model.intellectualPropertyInsuranceEntries.slice()
      sortedIntellectualPropertyInsurance.sort((a, b) => sortIntellectualPropertyInsurance(a, b))

      // Earnings
      const sortedGoods = this.props.model.goodsEntries.slice()
      sortedGoods.sort((a, b) => sortGoods(a, b))

      const sortedServicesIPRKnowHow = this.props.model.servicesIPRKnowHowEntries.slice()
      sortedServicesIPRKnowHow.sort((a, b) => sortServicesIPRKnowHow(a, b))

      const sortedTourismServices = this.props.model.tourismServicesEntries.slice()
      sortedTourismServices.sort((a, b) => sortTourismServices(a, b))

      const sortedEventPromoters = this.props.model.eventPromoterEntries.slice()
      sortedEventPromoters.sort((a, b) => sortEventPromoters(a, b))

      const sortedRelatedEntities = this.props.model.relatedEntityEntries.slice()
      sortedRelatedEntities.sort((a, b) => sortRelatedEntities(a, b))

      // #endregion Sorting Lists

      const directorsOrPartnersRequired = this.props.model.businessCategory == BusinessCategories.Company
            || this.props.model.businessCategory == BusinessCategories.Partnership
            || (this.props.model.businessCategory == BusinessCategories.Trust
                && this.props.model.trusteeAcn != null
                && this.props.model.trusteeAcn != undefined
                && this.props.model.trusteeAcn != '')

      const performanceMeasureRequired = this.props.model.grantsReceived
            && this.props.model.grantsReceivedCount >= 2
            && this.props.model.businessCategory != BusinessCategories.ApprovedBody

      return (
        <>
          <h2 className="form-hidden-preview">Prepare claim</h2>

          <Table<Stakeholder>
            ref={(r) => this.stakeholders = r}
            header={<Button id="btnAddStakeholder" className="prepare-btn" onClick={(e) => this.props.history.push(`/claim/${this.props.model.claimId}/prepare/stakeholders`)}>Add/Edit</Button>}
            label="Directors or partners in the partnership"
            id="stakeholders"
            value={this.props.model.stakeholders}
            onChange={(stakeholders) => this.props.onChange({ stakeholders })}
            columns={stakeholderColumns}
            renderSection={(p) => <StakeholderDetails {...p} preview />}
            preview={this.props.preview}
            required={directorsOrPartnersRequired}
            visible={directorsOrPartnersRequired}
            alwaysShowAllRows
          />
          <Table<FinancialAssistance>
            ref={(r) => this.financialAssistance = r}
            header={<Button id="btnAddFinancialAssistance" className="prepare-btn" onClick={(e) => this.props.history.push(`/claim/${this.props.model.claimId}/prepare/financialassistance`)}>Add/Edit</Button>}
            label="Grants or reimbursement received from government or third parties"
            id="financialAssistance"
            value={this.props.model.financialAssistance}
            onChange={(financialAssistance) => this.props.onChange({ financialAssistance })}
            columns={financialAssistanceColumns}
            renderSection={(p) => <FinancialAssistanceDetails {...p} preview />}
            preview={this.props.preview}
            required={this.props.model.claimFinancialAssistance}
            visible={this.props.model.claimFinancialAssistance}
            alwaysShowAllRows
          />
          <Table<ClaimRelationship>
            ref={(r) => this.relationships = r}
            header={<Button id="btnAddRelationship" className="prepare-btn" onClick={(e) => this.props.history.push(`/claim/${this.props.model.claimId}/prepare/relationships`)}>Add/Edit</Button>}
            label="Schedule 11: Related companies"
            id="relationships"
            value={this.props.model.relationships}
            onChange={(relationships) => this.props.onChange({ relationships })}
            columns={relationshipColumns}
            renderSection={(p) => <RelationshipDetails {...p} preview claim={this.props.model} addressCountries={this.props.addressCountries} />}
            preview={this.props.preview}
            required={this.props.model.claimRelatedCompanies}
            visible={this.props.model.businessCategory == BusinessCategories.Company && this.props.model.claimRelatedCompanies}
            alwaysShowAllRows
          />

          <div className="form-container-landscape">
            <h3>Expense details</h3>

            <Alert className="emdg-page-alerts">
              <p>
                Do NOT claim Australian taxes such as GST.
                <br />
                Do not include amounts that you have been reimbursed.
                <br />
                Apportion expenses for expenses that are partially ineligible.
                <br />
                The use of notes to provide details of expenses and apportionment will help us assess your application faster.
              </p>

            </Alert>

            <div tabIndex={-1} ref={(r) => this.expensesError = r} className="mt-3" style={{ display: this.state.validated && !this.areExpensesValid() ? '' : 'none' }}>
              <Alert className="emdg-page-alerts emdg-page-alerts--error">
                The total expenses entered is less than the threshold of $15,000 and the application cannot be submitted
              </Alert>
            </div>

            <div className="form-container-newPage">
              <Table<Representation>
                ref={(r) => this.representation = r}
                header={<Button id="btnAddOverseasRepresentative" className="prepare-btn" onClick={(e) => this.props.history.push(`/claim/${this.props.model.claimId}/prepare/representation`)}>Add</Button>}
                label="Schedule 1A: Overseas representation"
                id="representation"
                value={this.props.model.representations}
                onChange={(representations) => this.props.onChange({ representations })}
                columns={representationColumns(this.props.history, this.props.model.claimId, this.props.preview)}
                renderSection={(p) => <RepresentationDetails {...p} preview claim={this.props.model} addressCountries={this.props.addressCountries} markets={this.props.markets} />}
                preview={this.props.preview}
                required={this.props.model.claimOverseasRepExpenses}
                visible={this.props.model.claimOverseasRepExpenses}
                total={calculateAllRepresentativesTotal}
                alwaysShowAllRows
                additionalTableClasses="form-container-extraWide"
              />
            </div>

            {this.props.preview && this.props.model.representations.map((rep, index) => {
              const sortedRepEntries = rep.entries.slice()
              sortedRepEntries.sort((a, b) => sortRepresentationEntries(a, b))

              return (
                <div key={index} className="form-container-newPage">
                  <Table<RepresentationEntry>
                    id={`table_${rep.id}`}
                    label={`Schedule 1A: Overseas representation expenses - for ${rep.firstName} ${rep.lastName}`}
                    ref={(r) => this.representationEntry = r}
                    value={sortedRepEntries}
                    columns={repEntryColumns}
                    renderSection={(p, i) => <RepresentationEntryDetails {...p} markets={this.props.markets} claim={this.props.model} preview={this.props.preview} />}
                    importUrl="/api/representation/import"
                    exportUrl="/api/representation/export"
                    visible={this.props.model.claimOverseasRepExpenses}
                    required
                    preview
                    total={calculateRepresentationTotal}
                  />
                </div>
              )
            })}

            <div className="form-container-newPage">
              <Table<MarketingConsultant>
                ref={(r) => this.marketingConsultant = r}
                header={<Button id="btnAddMarketingConsultant" className="prepare-btn" onClick={(e) => this.props.history.push(`/claim/${this.props.model.claimId}/prepare/marketingconsultants`)}>Add</Button>}
                label="Schedule 1B: Marketing consultants"
                id="marketingConsultant"
                value={this.props.model.marketingConsultants}
                onChange={(marketingConsultants) => this.props.onChange({ marketingConsultants })}
                columns={marketingConsultantColumns(this.props.history, this.props.model.claimId, this.props.preview)}
                renderSection={(p) => <MarketingConsultantDetails {...p} preview claim={this.props.model} addressCountries={this.props.addressCountries} markets={this.props.markets} />}
                preview={this.props.preview}
                required={this.props.model.claimMarketingConsultantExpenses}
                visible={this.props.model.claimMarketingConsultantExpenses}
                total={calculateAllConsultantsTotal}
                alwaysShowAllRows
                additionalTableClasses="form-container-extraWide"
              />
            </div>

            {this.props.preview && this.props.model.marketingConsultants.map((consultant, index) => {
              const sortedConsultantEntries = consultant.entries.slice()
              sortedConsultantEntries.sort((a, b) => sortMarketingConsultantEntries(a, b))

              return (
                <div key={index} className="form-container-newPage">
                  <Table<MarketingConsultantEntry>
                    id={`table_${consultant.id}`}
                    label={`Schedule 1B: Marketing consultant expenses - for ${consultant.firstName} ${consultant.lastName}`}
                    ref={(r) => this.marketingConsultantsEntry = r}
                    value={sortedConsultantEntries}
                    columns={marketingConsultantsEntryColumns}
                    renderSection={(p, i) => <MarketingConsultantEntryDetails {...p} markets={this.props.markets} claim={this.props.model} preview={this.props.preview} />}
                    required
                    visible={this.props.model.claimMarketingConsultantExpenses}
                    preview
                    total={calculateMarketingConsultantTotal}
                  />
                </div>
              )
            })}

            <div className="form-container-newPage">
              <Table<MarketingVisitEntry>
                ref={(r) => this.marketingVisits = r}
                header={<Button id="btnAddMarketingVisit" className="prepare-btn" onClick={(e) => this.props.history.push(`/claim/${this.props.model.claimId}/prepare/marketingvisits`)}>Add / Edit</Button>}
                label="Schedule 2: Marketing visits"
                id="marketingVisits"
                value={sortedMarketingVisits}
                onChange={(marketingVisitEntries) => this.props.onChange({ marketingVisitEntries })}
                columns={marketingVisitEntryColumns(this.props.markets)}
                renderSection={(p) => <MarketingVisitEntryDetails {...p} preview markets={this.props.markets} claim={this.props.model} />}
                preview={this.props.preview}
                required={this.props.model.claimMarketingVisitExpenses}
                visible={this.props.model.claimMarketingVisitExpenses}
                total={calculateMarketingVisitTotal}
                additionalTableClasses="form-container-extraWide"
              />
            </div>
            <div className="form-container-newPage">
              <Table<FreeSampleEntry>
                ref={(r) => this.freeSamples = r}
                header={<Button id="btnAddFreeSample" className="prepare-btn" onClick={(e) => this.props.history.push(`/claim/${this.props.model.claimId}/prepare/freesamples`)}>Add / Edit</Button>}
                label="Schedule 4: Free samples"
                id="freeSamples"
                value={sortedFreeSamples}
                onChange={(freeSampleEntries) => this.props.onChange({ freeSampleEntries })}
                columns={freeSampleEntryColumns(this.props.markets)}
                renderSection={(p) => <FreeSampleEntryDetails {...p} preview markets={this.props.markets} claim={this.props.model} />}
                preview={this.props.preview}
                required={this.props.model.claimFreeSampleExpenses}
                visible={this.props.model.claimFreeSampleExpenses}
                total={calculateFreeSampleTotal}
              />
            </div>
            <div className="form-container-newPage">
              <Table<PromotionalEventEntry>
                ref={(r) => this.promotionalEvents = r}
                header={<Button id="btnAddTradeFairPromotion" className="prepare-btn" onClick={(e) => this.props.history.push(`/claim/${this.props.model.claimId}/prepare/promotionalevents`)}>Add / Edit</Button>}
                label="Schedule 5: Trade fairs and promotional events"
                id="promotionalEvents"
                value={sortedPromotionalEvents}
                onChange={(promotionalEventEntries) => this.props.onChange({ promotionalEventEntries })}
                columns={promotionalEventEntryColumns(this.props.markets)}
                renderSection={(p) => <PromotionalEventEntryDetails {...p} preview markets={this.props.markets} claim={this.props.model} />}
                preview={this.props.preview}
                required={this.props.model.claimTradeFairsPromotionalEventsExpenses}
                visible={this.props.model.claimTradeFairsPromotionalEventsExpenses}
                total={calculatePromotionalEventTotal}
              />
            </div>
            <div className="form-container-newPage">
              <Table<AdvertisingEntry>
                ref={(r) => this.advertising = r}
                header={<Button id="btnAddPromotionalLiteratureAdvertising" className="prepare-btn" onClick={(e) => this.props.history.push(`/claim/${this.props.model.claimId}/prepare/advertising`)}>Add / Edit</Button>}
                label="Schedule 6: Promotional literature and advertising"
                id="advertising"
                value={sortedAdvertising}
                onChange={(advertisingEntries) => this.props.onChange({ advertisingEntries })}
                columns={advertisingEntryColumns(this.props.markets)}
                renderSection={(p) => <AdvertisingEntryDetails {...p} preview markets={this.props.markets} claim={this.props.model} />}
                preview={this.props.preview}
                required={this.props.model.claimPromotionalLiteratureAdvertisingExpenses}
                visible={this.props.model.claimPromotionalLiteratureAdvertisingExpenses}
                total={calculateAdvertisingTotal}
              />
            </div>
            <div className="form-container-newPage">
              <Table<OverseasBuyerEntry>
                ref={(r) => this.overseasBuyers = r}
                header={<Button id="btnAddOverseasBuyer" className="prepare-btn" onClick={(e) => this.props.history.push(`/claim/${this.props.model.claimId}/prepare/overseasbuyers`)}>Add / Edit</Button>}
                label="Schedule 7: Overseas buyers"
                id="overseasBuyers"
                value={sortedOverseasBuyer}
                onChange={(overseasBuyerEntries) => this.props.onChange({ overseasBuyerEntries })}
                columns={overseasBuyerEntryColumns(this.props.markets)}
                renderSection={(p) => <OverseasBuyerEntryDetails {...p} preview markets={this.props.markets} claim={this.props.model} />}
                preview={this.props.preview}
                required={this.props.model.claimOverseasBuyersExpenses}
                visible={this.props.model.claimOverseasBuyersExpenses}
                total={calculateOverseasBuyerTotal}
              />
            </div>
            <div className="form-container-newPage">
              <Table<IntellectualPropertyRegistrationEntry>
                ref={(r) => this.intellectualPropertyRegistration = r}
                header={<Button id="btnAddIpRegistration" className="prepare-btn" onClick={(e) => this.props.history.push(`/claim/${this.props.model.claimId}/prepare/intellectualpropertyregistration`)}>Add / Edit</Button>}
                label="Schedule 8: Registration of eligible intellectual property (IP)"
                id="intellectualPropertyRegistration"
                value={sortedIntellectualPropertyRegistration}
                onChange={(intellectualPropertyRegistrationEntries) => this.props.onChange({ intellectualPropertyRegistrationEntries })}
                columns={intellectualPropertyRegistrationEntryColumns(this.props.markets)}
                renderSection={(p) => <IntellectualPropertyRegistrationEntryDetails {...p} preview markets={this.props.markets} claim={this.props.model} />}
                preview={this.props.preview}
                required={this.props.model.claimIpRegistrationExpenses}
                visible={this.props.model.claimIpRegistrationExpenses}
                total={calculateIntellectualPropertyRegistrationTotal}
              />
            </div>
            <div className="form-container-newPage">
              <Table<IntellectualPropertyInsuranceEntry>
                ref={(r) => this.intellectualPropertyInsurance = r}
                header={<Button id="btnAddIpInsurance" className="emdg-btn prepare-btn" onClick={(e) => this.props.history.push(`/claim/${this.props.model.claimId}/prepare/intellectualpropertyinsurance`)}>Add / Edit</Button>}
                label="Schedule 9: Insurance of eligible intellectual property (IP)"
                id="intellectualProperty"
                value={sortedIntellectualPropertyInsurance}
                onChange={(intellectualPropertyInsuranceEntries) => this.props.onChange({ intellectualPropertyInsuranceEntries })}
                columns={intellectualPropertyInsuranceEntryColumns(this.props.markets)}
                renderSection={(p) => <IntellectualPropertyInsuranceEntryDetails {...p} preview markets={this.props.markets} claim={this.props.model} />}
                preview={this.props.preview}
                required={this.props.model.claimIpInsuranceExpenses}
                visible={this.props.model.claimIpInsuranceExpenses}
                total={calculateIntellectualPropertyInsuranceTotal}
              />
            </div>

            <div className="form-container-newPage" style={{ display: this.props.model.noExportEarningReceived ? 'none' : '' }}>
              <h3>Export earning details</h3>
              <Table<GoodsEntry>
                ref={(r) => this.goods = r}
                header={<Button id="btnAddGoods" className="emdg-btn prepare-btn" onClick={(e) => this.props.history.push(`/claim/${this.props.model.claimId}/prepare/goods`)}>Add / Edit</Button>}
                label="Schedule 10A: Export earnings - Goods"
                id="goods"
                value={sortedGoods}
                onChange={(goodsEntries) => this.props.onChange({ goodsEntries })}
                columns={goodsEntryColumns(this.props.markets)}
                renderSection={(p) => <GoodsEntryDetails {...p} preview markets={this.props.markets} claim={this.props.model} />}
                preview={this.props.preview}
                required={this.props.model.claimGoodEarnings}
                visible={this.props.model.claimGoodEarnings}
                total={calculateGoodsTotal}
              />
            </div>
            <div className="form-container-newPage">
              <MultiLineField
                ref={(r) => this.serviceIPRKnowHowDescription = r}
                id="serviceDescription"
                label="Fully describe the Services/Intellectual property rights/Know-how"
                value={this.props.model.serviceIPRKnowHowDescription}
                onChange={(serviceIPRKnowHowDescription) => this.props.onChange({ serviceIPRKnowHowDescription })}
                maxLength={2000}
                preview={this.props.preview}
                visible={this.props.model.claimServiceEarnings && this.props.preview === true}
              />

              <Table<ServicesIPRKnowHowEntry>
                ref={(r) => this.servicesIPRKnowHow = r}
                header={<Button id="btnAddServiceIpKnowHow" className="emdg-btn prepare-btn" onClick={(e) => this.props.history.push(`/claim/${this.props.model.claimId}/prepare/servicesiprknowhow`)}>Add / Edit</Button>}
                label="Schedule 10B: Export earnings - Services/IP rights/Know-how"
                id="servicesIPRKnowHow"
                value={sortedServicesIPRKnowHow}
                onChange={(servicesIPRKnowHowEntries) => this.props.onChange({ servicesIPRKnowHowEntries })}
                columns={servicesIPRKnowHowEntryColumns(this.props.markets)}
                renderSection={(p) => <ServicesIPRKnowHowEntryDetails {...p} preview markets={this.props.markets} claim={this.props.model} />}
                preview={this.props.preview}
                required={this.props.model.claimServiceEarnings}
                visible={this.props.model.claimServiceEarnings}
                total={calculateServicesIPRKnowHowTotal}
              />
            </div>
            <div className="form-container-newPage">
              <MultiLineField
                ref={(r) => this.tourismServiceDescription = r}
                id="serviceDescription"
                label="Fully describe the nature of the service"
                value={this.props.model.tourismDescription}
                onChange={(tourismDescription) => this.props.onChange({ tourismDescription })}
                maxLength={2000}
                preview={this.props.preview}
                visible={this.props.model.claimTourismEarnings && this.props.preview === true}
              />

              <Table<TourismServicesEntry>
                ref={(r) => this.tourismServices = r}
                header={<Button id="btnAddTourism" className="emdg-btn prepare-btn" onClick={(e) => this.props.history.push(`/claim/${this.props.model.claimId}/prepare/tourismservices`)}>Add / Edit</Button>}
                label="Schedule 10C: Export earnings - Tourism services"
                id="tourismServices"
                value={sortedTourismServices}
                onChange={(tourismServicesEntries) => this.props.onChange({ tourismServicesEntries })}
                columns={tourismServicesEntryColumns(this.props.markets)}
                renderSection={(p) => <TourismServicesEntryDetails {...p} preview markets={this.props.markets} claim={this.props.model} />}
                preview={this.props.preview}
                required={this.props.model.claimTourismEarnings}
                visible={this.props.model.claimTourismEarnings}
                total={calculateTourismServicesTotal}
              />
            </div>
            <div className="form-container-newPage">
              <Table<EventPromoterEntry>
                ref={(r) => this.eventPromoters = r}
                header={<Button id="btnAddEventPromoter" className="emdg-btn prepare-btn" onClick={(e) => this.props.history.push(`/claim/${this.props.model.claimId}/prepare/eventpromoters`)}>Add / Edit</Button>}
                label="Schedule 10D: Export earnings - Events promoters"
                id="eventPromoters"
                value={sortedEventPromoters}
                onChange={(eventPromoterEntries) => this.props.onChange({ eventPromoterEntries })}
                columns={eventPromoterEntryColumns(this.props.markets)}
                renderSection={(p) => <EventPromoterEntryDetails {...p} preview markets={this.props.markets} claim={this.props.model} />}
                preview={this.props.preview}
                required={this.props.model.claimEventEarnings}
                visible={this.props.model.claimEventEarnings}
                total={calculateEventPromoterTotal}
              />
            </div>
            <div className="form-container-newPage">
              <Table<RelatedEntityEntry>
                ref={(r) => this.relatedEntities = r}
                header={<Button id="btnAddRelatedEntity" className="emdg-btn prepare-btn" onClick={(e) => this.props.history.push(`/claim/${this.props.model.claimId}/prepare/relatedentities`)}>Add / Edit</Button>}
                label="Schedule 10E: Export earnings - Related entities"
                id="relatedEntities"
                value={sortedRelatedEntities}
                onChange={(relatedEntityEntries) => this.props.onChange({ relatedEntityEntries })}
                columns={relatedEntityEntryColumns(this.props.markets)}
                renderSection={(p) => <RelatedEntityEntryDetails {...p} preview markets={this.props.markets} claim={this.props.model} />}
                preview={this.props.preview}
                required={this.props.model.claimEntityEarnings}
                visible={this.props.model.claimEntityEarnings}
                total={calculateRelatedEntityTotal}
              />
            </div>
          </div>

          <h3 style={{ display: performanceMeasureRequired ? '' : 'none' }}>Performance Measure</h3>
          <NumericButtonField
            ref={(r) => this.performanceMeasure = r}
            id="performanceMeasure"
            label={this.props.model.claimYear == 2020
              ? (
                <span>
                  45. In response to the economic impact of COVID-19, the government has removed the export performance test for grant year 2019-20 (financial year 20-21). For more information, please see
                  <a href="https://www.trademinister.gov.au/minister/simon-birmingham/media-release/funding-boost-support-australian-exporters-and-tourism-businesses" target="_blank" rel="noreferrer">link</a>
                </span>
              )
              : (
                <span>
                  45. If you have received two or more grants, and you are not an Approved Body, you must choose a
                  <a href="https://www.austrade.gov.au/ArticleDocuments/1433/EMDG-Performance-Measure-Fact-Sheet.pdf.aspx" target="_blank" rel="noreferrer">performance measure</a>
                  {' '}
                  option. Take care in making this selection as it is irreversible after you have submitted your Application.
                </span>
              )}

            onChange={(performanceMeasure) => this.changeAndSave({ performanceMeasure })}
            value={this.props.model.performanceMeasure}
            dataSource={performanceMeasureDataSource}
            required={performanceMeasureRequired && this.props.model.claimYear != 2020} // Performance measure test has been removed for the 2019-20 grant year
            disabled={this.props.model.claimYear == 2020} // Performance measure test has been removed for the 2019-20 grant year
            visible={performanceMeasureRequired}
            preview={this.props.preview}
          />
          {!this.props.preview && (
            <div style={{ display: performanceMeasureRequired && this.props.model.claimYear != 2020 ? '' : 'none' }}>
              <GrantEstimation model={this.props.model} />
            </div>
          )}
          <h3>Supporting Documents</h3>
          <div id="supportingDocumentSection">
            {!this.props.preview ? (
              <>
                {documentTypeInfo.map((r) => (
                  <Fragment key={r.code}>
                    {r.reducer(this.props.model, this.props.lowRiskMarkets).map((i) => (
                      <ApplicationForm1DocumentSection
                        key={i}
                        ref={(_) => this.setDocumentRef(r.code, i, _)}
                        model={this.props.model}
                        info={r}
                        item={i}
                        onChange={(documents) => this.props.onChange({ ...documents })}
                        history={this.props.history}
                      />
                    ))}
                  </Fragment>
                ))}
              </>
            ) : (
              <>
                <table className="table table-sm mt-3">
                  <thead>
                    <tr>
                      <th>Category</th>
                      <th>Attached file</th>
                    </tr>
                  </thead>
                  <tbody>
                    {documentTypeInfo.map((r) => (
                      <Fragment key={r.code}>
                          {r.reducer(this.props.model, this.props.lowRiskMarkets).map((i) => (
                  <tr key={i}>
                              <td>{r.title(this.props.model, i)}</td>
                              <td>
                  {this.props.model.documents.filter((d) => d.code == r.code && d.itemId == i).map((f, m) => (
                  <Fragment key={m}>
                                          {f.name}
                                          <br />
                                        </Fragment>
                ))}
                </td>
                            </tr>
                ))}
                        </Fragment>
                    ))}
                  </tbody>
                </table>
              </>
            )}
          </div>
          <div className="mt-3 mb-3" style={{ display: this.props.model.machineLearningWithScore && invalidDocumentUploaded(this.props.model, this.props.lowRiskMarkets) ? '' : 'none' }}>
            <Alert className="emdg-page-alerts emdg-page-alerts--warning">
              One or more of the uploaded file(s) do not appear to be correct. Please double check and confirm they are valid.
              <BooleanButtonField
                ref={(r) => this.docConfirmedAsValid = r}
                id="docConfirmedAsValid"
                label="I confirm that the document/s selected are correct"
                onChange={(docConfirmedAsValid) => this.changeAndSave({ docConfirmedAsValid })}
                value={this.props.model.docConfirmedAsValid}
                required={this.props.model.machineLearningWithScore && invalidDocumentUploaded(this.props.model, this.props.lowRiskMarkets)}
                dataSource={yesNoDataSource}
                enforceValue
                preview={this.props.preview}
              />
            </Alert>
            <br />
            <div style={{ display: this.props.model.docConfirmedAsValid ? '' : 'none' }}>
              <Alert className="emdg-page-alerts">
                <p>
                  Your acknowledgement has been recorded.
                </p>
              </Alert>
            </div>
          </div>

          <NextBackButtons
            onBack={() => this.props.history.push(`/claim/${this.props.model.claimId}/personalise`)}
            nextLabel="Review"
            onNext={this.next}
            preview={this.props.preview}
          />

          <Backdrop on={this.state.loading} />
        </>
      )
    }
}
